<div class="d-flex align-items-center gap-3">
  <div class="showing-results-text" i18n>
    @if (noResults()) {
      No Results
    } @else {
      Showing
      <lib-inline-loading-shimmer [showLoading]="loading()">
        <span>{{ currentPageMin() }}</span>
      </lib-inline-loading-shimmer>
      to
      <lib-inline-loading-shimmer [showLoading]="loading()">
        <span>{{ currentPageMax() }}</span>
      </lib-inline-loading-shimmer>
      of
      <lib-inline-loading-shimmer [showLoading]="loading()">
        <span>{{ totalCount() ?? 0 }}</span>
      </lib-inline-loading-shimmer>
      results
    }
  </div>

  <div class="ms-auto d-flex align-items-center">
    <div class="page-number previous-button" (click)="previousPageClicked()">
      <mat-icon class="page-number-nav-icon" [svgIcon]="'chevron-left'"></mat-icon>
    </div>
    @for (page of paginationButtonsArray(); track $index) {
      @let isEllipses = page === '...';
      @let isSelected = page !== '...' && page === currentPageIndex() + 1;
      <div
        class="page-number"
        [class.ellipses]="isEllipses"
        [class.selected-page]="isSelected"
        (click)="pageClicked(page)">
        @if (isEllipses) {
          <mat-icon class="ellipses-icon" [svgIcon]="'more-horizontal'"></mat-icon>
        } @else {
          {{ page }}
        }
      </div>
    }
    <div class="page-number next-button" (click)="nextPageClicked()">
      <mat-icon class="page-number-nav-icon" [svgIcon]="'chevron-right'"></mat-icon>
    </div>
  </div>
</div>
